// Copyright 2016 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Router, RouterConfiguration } from "aurelia-router";
import { MediaQueries } from "libraries/MediaQueries/MediaQueries";
import { RouterManager } from "modules/shell/App/RouterManager";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";

@autoinject
export class App {
    constructor(
        private readonly shellViewManager: ShellViewManager,
        private readonly routerManager: RouterManager,
        private readonly mediaQueries: MediaQueries
    ) {}

    public configureRouter(config: RouterConfiguration, router: Router) {
        this.routerManager.configureRouter(config, router);
    }
}
